<template>
  <div>
    <!-- BOC:[error] -->
    <AErrorV1 :api="api"></AErrorV1>
    <!-- EOC -->
    <!-- BOC:[form] -->
    <v-form ref="form" lazy-validation @submit.prevent="validate">
      <v-card>
        <v-card-title>Edit Plan</v-card-title>
        <v-card-text>
          <template>
            <FormInput
              :value="form['translatableName']"
              label="Translatable Name"
              :rules="nameRules"
              @input="form['translatableName'] = $event"
            />
          </template>
          <template>
            <FormTextArea
              :value="form['translatableDescription']"
              label="Translatable Description"
              :rules="summaryRules"
              @input="form['translatableDescription'] = $event"
            />
          </template>
          <template>
            <FormInput
              :value="form['key']"
              label="Key"
              :rules="keyRules"
              @input="form['key'] = $event"
            />
          </template>
          <template>
            <FormInput
              :value="form['pricePerMonth']"
              label="Price Per Month"
              :rules="priceRules"
              type="number"
              @input="form['pricePerMonth'] = $event"
            />
          </template>
          <template>
            <PlanPricing
            :self="self"
              :value="form['bestPricingKey']"
              @input="form['bestPricingKey'] = $event"
            />
          </template>
          <template>
            <FormSelect label="Type" :data="types" :value="form['type']" @input="form['type'] = $event"></FormSelect>
          </template>
          <template>
            <FormImage
              :value="form['image']"
              label="Image"
              @input="form['image'] = $event"
            />
          </template>
          <template>
            <FormInput
            v-if="form.type == 'sub'"
              :value="form['redirectUrl']"
              label="Redirect Url"
              @input="form['redirectUrl'] = $event"
            />
          </template>
          <template>
            <FormRadio
              :value="form['isPublished']"
              label="Published"
              @input="form['isPublished'] = $event"
            />
          </template>
          <template>
            <FormDate
              :callbackSelect="selectDate"
              formKey="dateStart"
              name="Start Date"
              :value="form.dateStart"
            />
          </template>
          <template>
            <FormTime
              :callbackSelect="selectTime"
              formKey="timeStart"
              name="Start Time"
              :value="form.timeStart"
            />
          </template>
          <template>
            <FormDate
              :callbackSelect="selectDate"
              formKey="dateEnd"
              name="End Date"
              :value="form.dateEnd"
            />
          </template>
          <template>
            <FormTime
              :callbackSelect="selectTime"
              formKey="timeEnd"
              name="End Time"
              :value="form.timeEnd"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)"> Cancel </v-btn>
          <v-btn color="primary" :loading="api.isLoading" @click="validate">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import FormInput from "@/components/Moderator/Plan/FormInput";
import FormSelect from "@/components/Moderator/Plan/FormSelect";
import FormRadio from "@/components/Moderator/Plan/FormRadio";
import FormDate from "@/components/Moderator/Plan/FormDate";
import FormTime from "@/components/Moderator/Plan/FormTime";
import FormImage from "@/components/Moderator/Plan/FormImage";
import FormTextArea from "@/components/Moderator/Plan/FormTextArea";

import moment from "moment";

import axios from "axios";
import store from "../../../store";
import { mapState } from "vuex";
import PlanPricing from "./PlanPricing.vue";
export default {
  props: ["data","self", "callbackSuccess"],
  components: {
    FormInput,
    FormSelect,
    FormRadio,
    FormDate,
    FormTime,
    FormImage,
    FormTextArea,
    PlanPricing
  },
  computed: mapState({
    
  }),
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    types:[{name:'Primary',key:'primary'},{name:'Sub',key:'sub'}],
    //BOC:[form]
    form: {
      id: null,
      translatableName: '{"en":"New Plan Name","ms":"Nama Pelan Baharu","zh":"新计划名称"}',
      translatableDescription: '{"en":"","ms":"","zh":""}',
      key: null,
      image: null,
      isPublished: false,
      type: "primary",
      dateStart: null,
      dateEnd: null,
      timestampStart: null,
      timestampEnd: null,
      timeStart: null,
      timeEnd: null,
      redirectUrl: null,
      pricePerMonth: null,
      bestPricingKey: null
    },
    fields: [],
    rules: {},
    keyRules: [],
    nameRules: [],
    summaryRules:[],
    priceRules:[],
    //EOC
  }),

  created() {
    //BOC:[api]
    this.api.url = `${this.$api.servers.game}/api/v1/en/moderator/plan/add`;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.api.error = null;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.callbackSuccess(resp);
    };
    //EOC
  },
  mounted() {
    this.form.id = this.$route.params.id;
    this.form.translatableName = this.self.translatableName;
   this.form.translatableDescription = this.self.translatableDescription;
    this.form.key = this.self.key;
    this.form.image = this.self.imageUrl ?  this.self.imageUrl : null
    this.form.isPublished = this.self.isPublished;
    this.form.type = this.self.type;
    this.form.bestPricingKey = this.self.bestPricingKey;
    this.form.redirectUrl = this.self.redirectUrl;
    this.form.pricePerMonth = this.self.pricePerMonth;
    this.form.dateStart =this.self.timestampStart ? moment(this.self.timestampStart).format("YYYY-MM-DD") : null;
    this.form.dateEnd = this.self.timestampEnd ? moment(this.self.timestampEnd).format("YYYY-MM-DD") : null;
    this.form.timeStart = this.self.timestampStart ? moment(this.self.timestampStart).format("HH:mm") : null;
    this.form.timeEnd = this.self.timestampEnd ? moment(this.self.timestampEnd).format("HH:mm") : null;
  },
  methods: {
    selectDate(date, key) {
      if (key == "dateStart") {
        this.form.dateStart = date;
      } else {
        this.form.dateEnd = date;
      }
    },
    selectTime(time, key) {
      if (key == "timeStart") {
        this.form.timeStart = time;
      } else {
        this.form.timeEnd = time;
      }
    },
    //BOC:[form]
    validate() {
      this.api.callbackReset();
      this.nameRules = [(v) => !!v || "Translatable name is required"];
      this.keyRules = [(v) => !!v || "Plan key is required"];
      this.summaryRules = [(v) => !!v || "Plan description is required"];
      this.priceRules = [(v) => !!v || "Price per month is required"];

      if (this.$refs.form.validate()) {
        this.form.timestampStart = moment(
          this.form.dateStart + " " + this.form.timeStart
        ).toISOString();
        this.form.timestampEnd = moment(
          this.form.dateEnd + " " + this.form.timeEnd
        ).toISOString();
        if (this.form.timestampStart > this.form.timestampEnd) {
          this.api.callbackError(
            "The plan start date and time should be less than the plan end date and time."
          );
        } else {
          this.submit();
        }
      } else {
        this.api.callbackError("Please check the form.");
      }
    },
    async submit() {
      // this.api.params = this.$_.clone(this.form);
      // this.$api.fetch(this.api);
      this.api.isLoading = true;
      const formData = new FormData();
      const token = "Bearer " + store.state.auth.data.Session.token;
      const config = {
        headers: { Authorization: token },
      };
      formData.append(
        "id",
        this.form.id
      );
      formData.append(
        "translatableName",
        this.form.translatableName
      );
      formData.append(
        "translatableDescription",
        this.form.translatableDescription
      );
      formData.append("key", this.form.key);
      formData.append("image", this.form.image);
      formData.append("redirectUrl", this.form.redirectUrl);
      formData.append("isPublished", this.form.isPublished);
      formData.append("type", this.form.type);
      formData.append("timestampStart", this.form.timestampStart);
      formData.append("timestampEnd", this.form.timestampEnd);
      formData.append("pricePerMonth", this.form.pricePerMonth);
      formData.append("bestPricingKey", this.form.bestPricingKey);
      try {
    // Make the API request
    const response = await axios.post(
      this.$api.servers.sso + "/api/v1/en/moderator/plan/edit",
      formData,
      config
    );

    this.api.isLoading = false;
    this.callbackSuccess(response.data);
  } catch (error) {
    this.api.isLoading = false;
    this.api.isLoading = false;
    this.api.isError = true;
    this.api.error = error;
  }
    },
    //EOC
  },
};
</script>

<style>
</style>